import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_351_19)">
        <path
          fill="#3F434A"
          d="M8.035.356C3.787.356.355 3.804.355 8.053c0 4.25 3.45 7.68 7.698 7.68a7.67 7.67 0 007.68-7.68A7.69 7.69 0 008.035.356zm.978 2.542l-.355 7.324H7.43l-.356-7.324h1.938zm-.178 9.99a1.21 1.21 0 01-.8.303c-.302 0-.568-.107-.782-.32a1.005 1.005 0 01-.338-.782c0-.32.107-.587.338-.782.196-.196.462-.303.782-.303s.605.107.8.303c.214.213.32.462.32.782s-.106.586-.32.8z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_351_19">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
